module.exports = __webpack_public_path__ + "media/images/howTo__bg-318876830c61a2c531cdd27116c31582.png";